















































import { Component, Vue } from "vue-property-decorator";
import types from "./types";
@Component
export default class Type extends Vue {
  public data() {
    return {
      types,
    };
  }

  public next() {
    this.$router.push({ path: "/create/2/1" });
  }
}
